export enum EBroadcustChannel {
  SubmitOptions = 'submit-options',
}

export type Channel = 'submit-options';
